import { createStore } from 'zustand';
import type { StoreApi } from 'zustand';

import appConstants from '@/constants/appConstants';

import type { ServiceReminder } from '../types/ServiceReminder';

export type ServiceRemindersState = {
    selectedServiceReminder: ServiceReminder | null;
};

export type ServiceRemindersActions = {
    updateSelectedServiceReminder: (serviceReminder: ServiceRemindersState['selectedServiceReminder']) => void;
    resetStore: () => void;
};

export type ServiceRemindersStore = ServiceRemindersState & ServiceRemindersActions;

export const initialState: ServiceRemindersState = {
    selectedServiceReminder: null,
};

export function getStoredState(): ServiceRemindersState {
    if (typeof window === 'undefined') return initialState;

    const storedServiceReminder = sessionStorage.getItem(appConstants.selectedServiceReminderStorageName);

    return {
        selectedServiceReminder: storedServiceReminder ? (JSON.parse(storedServiceReminder) as ServiceReminder) : null
    };
}

export function createServiceRemindersStore(serviceRemindersState: ServiceRemindersState = getStoredState()): StoreApi<ServiceRemindersStore> {
    return createStore<ServiceRemindersStore>()((set) => ({
        ...serviceRemindersState,
        updateSelectedServiceReminder: (serviceReminder): void => {
            sessionStorage.setItem(appConstants.selectedServiceReminderStorageName, JSON.stringify(serviceReminder));
            set(() => ({ selectedServiceReminder: serviceReminder }));
        },
        resetStore: (): void => {
            sessionStorage.removeItem(appConstants.selectedServiceReminderStorageName);
            sessionStorage.removeItem(appConstants.vehicleIdStorageName);
            set(initialState);
        },
    }));
}
